import { render, staticRenderFns } from "./Scheduler_event_modal.vue?vue&type=template&id=2b89df48&scoped=true&lang=pug&"
import script from "./Scheduler_event_modal.vue?vue&type=script&lang=js&"
export * from "./Scheduler_event_modal.vue?vue&type=script&lang=js&"
import style0 from "./Scheduler_event_modal.vue?vue&type=style&index=0&id=2b89df48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b89df48",
  null
  
)

export default component.exports